<template>
  <v-row class="px-4">
    <v-col cols="12" class="text-center font-weight-bold text-h6">
      Статистика для економиста на период с {{ startFilterDisplayValue }} по {{ endFilterDisplayValue }}
    </v-col>

    <v-col cols="12" md="4" class="d-print-none">
      <v-menu
          v-model="filterStartMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              v-model="startFilterDisplayValue"
              label="Начало периода"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="filters.start"
            @input="filterStartMenu = false"
            @change="onFilterStartChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
        ></v-date-picker>
      </v-menu>
    </v-col>

    <v-col cols="12" md="4" class="d-print-none">
      <v-menu
          v-model="filterEndMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              v-model="endFilterDisplayValue"
              label="Конец периода"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="filters.end"
            @input="filterEndMenu = false"
            @change="onFilterEndChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
        ></v-date-picker>
      </v-menu>
    </v-col>

    <v-col cols="12" md="4" class="d-flex align-center justify-center justify-md-end d-print-none">
      <v-btn @click="onRefreshClicked" color="primary" large class="me-2">Обновить</v-btn>
      <v-btn @click="onPrintClicked" color="secondary" large>Распечатать</v-btn>
    </v-col>

    <v-col cols="12">
      <v-simple-table dense>
        <template v-slot:default>
          <table class="report-table">
            <thead>
            <tr>
              <th class="text-left" rowspan="2">Регион</th>

              <th class="text-left" rowspan="2">Хатлар сони</th>

              <th class="text-center" colspan="2">Цена</th>

              <th class="text-center" colspan="2">Количество писем</th>



              <th class="text-center blue-grey lighten-4" colspan="2">Сумма</th>

              <th class="text-center" rowspan="2">Общее</th>
            </tr>
            <tr>
              <th class="text-center" style="min-width: 80px;">3 вароқгача</th>
              <th class="text-center" style="min-width: 80px;">3 вароқдан ортиқ</th>

              <!-- <th class="text-center">3 вароқгача</th> -->
              <th class="text-center">3 вароқдан ортиқ</th>
<th class="text-center">Жами</th>
              <th class="text-center blue-grey lighten-4" style="min-width: 120px;">(3 вароқгача)</th>
              <th class="text-center blue-grey lighten-4" style="min-width: 120px;">(3 вароқдан ортиқ)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in processedItems" :key="item.RegionId">
              <td class="text-left font-weight-medium">
                {{ item.displayRegionName }}
              </td>

              <td class="text-center">
                {{ item.TotalMailCount }}
              </td>

              <td class="text-center">{{ priceSimple }}</td>
              <td class="text-center">{{ priceOver }}</td>

              <!-- <td class="text-center">
                {{ (item.NormalPagesCount || 0).toLocaleString() }}
              </td> -->
              <td class="text-center">
                {{ (item.OverPagesSum || 0).toLocaleString() }}
              </td>

              <td class="text-center">
                {{ item.TotalPages }}
              </td>

              <td class="text-center font-weight-bold blue-grey lighten-5">
                {{ calculateBaseMailSum(item).toLocaleString() }}
              </td>

              <td class="text-center font-weight-bold blue-grey lighten-5">
                {{ calculateExcessSum(item).toLocaleString() }}
              </td>

              <td class="text-center font-weight-bold">
                {{ calculateRowTotal(item).toLocaleString() }}
              </td>
            </tr>

            <tr class="total-row">
              <td class="text-left font-weight-bold">Общее</td>
              <td class="text-center font-weight-bold">{{ totalMailAll.toLocaleString() }}</td>
              <td></td>

              <td class="text-center font-weight-bold">
                
              </td>

              <!-- <td class="text-center font-weight-bold">
                {{ totalCountUpTo3.toLocaleString() }}
              </td> -->

               <td class="text-center font-weight-bold">
                  {{ totalCountOver3.toLocaleString() }}
              </td>

              <td class="text-center font-weight-bold">
               {{ totalCountAll.toLocaleString() }}
              </td>

              <td class="text-center font-weight-black">
                {{ totalBaseSum.toLocaleString() }}
              </td>

              <td class="text-center font-weight-black">
                {{ totalExcessSum.toLocaleString() }}
              </td>

              <td class="text-center font-weight-black">{{ grandTotal.toLocaleString() }}</td>
            </tr>
            </tbody>
          </table>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import Moment from 'moment';
import { PRICE_SIMPLE_FOR_HYBRID, PRICE_OVER_PAGE_FOR_HYBRID } from '@/helpers/constants';

export default {
  name: "PagesEconomistReportComponent",
  props: {
    // Input data format: [{ RegionId, RegionName, CountUpTo3, CountOver3, ExcessPagesSum }, ...]
      items: {
        type: Array,
        default: () => []
      }
  },
  data() {
    const start = Moment().subtract(1, 'days');
    const end = Moment().subtract(1, 'days');

    return {
      filters: {
        start: start.format('YYYY-MM-DD'),
        end: end.format('YYYY-MM-DD'),
      },
      startFilterDisplayValue: start.format('DD.MM.YYYY'),
      endFilterDisplayValue: end.format('DD.MM.YYYY'),
      filterStartMenu: false,
      filterEndMenu: false,
      priceSimple: PRICE_SIMPLE_FOR_HYBRID, // 9850
      priceOver: PRICE_OVER_PAGE_FOR_HYBRID   // 300
    };
  },
  computed: {
    processedItems() {
      if (!this.items || !Array.isArray(this.items)) return [];

      return this.items.map(item => {
        const regionName = item.RegionName
            ? item.RegionName
            : this.getRegionNameById(item.RegionId);

        return {
          ...item,
          displayRegionName: regionName
        };
      }).sort((a, b) => {
        return (a.RegionId || 0) - (b.RegionId || 0);
      });
    },

    // --- Footer Totals ---
    totalCountUpTo3() {
      return this.processedItems.reduce((acc, item) => acc + (item.NormalPagesCount || 0), 0);
    },
    totalCountOver3() {
      return this.processedItems.reduce((acc, item) => acc + (item.OverPagesSum || 0), 0);
    },
     totalCountAll() {
      return this.processedItems.reduce((acc, item) => acc + (item.TotalPages || 0), 0);
    },
     totalMailAll() {
      return this.processedItems.reduce((acc, item) => acc + (item.TotalMailCount || 0), 0);
    },

    // Total for Base Sum column
    totalBaseSum() {
      return this.processedItems.reduce((acc, item) => acc + this.calculateBaseMailSum(item), 0);
    },

    // Total for Excess Sum column
    totalExcessSum() {
      return this.processedItems.reduce((acc, item) => acc + this.calculateExcessSum(item), 0);
    },

    grandTotal() {
      return this.totalBaseSum + this.totalExcessSum;
    }
  },
  methods: {
    updateItems() {
      const activeClientId = this.$store && this.$store.getters.appActiveClient ? this.$store.getters.appActiveClient.id : 1;
      const payload = {
        client: activeClientId,
        start: this.filters.start,
        end: this.filters.end
      };
      this.$emit('updated', payload);
    },

    onRefreshClicked() {
      this.updateItems();
    },

    onPrintClicked() {
      window.print();
    },

    onFilterStartChanged() {
      this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },

    onFilterEndChanged() {
      this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },

    // --- Switch Case for Region IDs ---
    getRegionNameById(id) {
      const numericId = Number(id);
      switch (numericId) {
        case 1: return "г.Ташкент";
        case 2: return "Ташкентская область";
        case 3: return "Самарканд вилояти";
        case 4: return "Жиззах вилояти";
        case 5: return "Сирдарё вилояти";
        case 6: return "Фаргона вилояти";
        case 7: return "Андижон вилояти";
        case 8: return "Наманган вилояти";
        case 9: return "Кашкадарё вилояти";
        case 10: return "Сурхондарё вилояти";
        case 11: return "Бухоро вилояти";
        case 12: return "Навоий вилояти";
        case 13: return "Коракалпогистон Республикаси";
        case 14: return "Хоразм вилояти";
        default: return `Неизвестный регион (${id})`;
      }
    },

    // --- NEW LOGIC CALCULATIONS ---

    // Column: Сумма (3 вароқгача)
    // Logic: (CountUpTo3 + CountOver3) * 9850
    calculateBaseSum(item) {
      const totalCount = (item.NormalPagesCount || 0);
      return totalCount * this.priceSimple;
    },

     calculateBaseMailSum(item) {
      const totalCount = (item.TotalMailCount || 0);
      return totalCount * this.priceSimple;
    },

    // Column: Сумма (3 вароқдан ортиқ)
    // Logic: ExcessPagesSum * 300
    calculateExcessSum(item) {
      return (item.OverPagesSum || 0) * this.priceOver;
    },

    // Total Column
    calculateRowTotal(item) {
      return this.calculateBaseMailSum(item) + this.calculateExcessSum(item);
    }
  },
  mounted() {
    this.updateItems();
  },
};
</script>

<style scoped>
.report-table {
  width: 100%;
  border-collapse: collapse;
}

.report-table th, .report-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.report-table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #f2f2f2;
  font-size: 14px;
}

.report-table tr:nth-child(even){background-color: #f9f9f9;}

.report-table tr:hover {
  background-color: #e6f7ff;
}

.total-row {
  background-color: #e3f2fd !important;
  font-size: 14px;
  border-top: 2px solid #90caf9;
}

@media print {
  .v-application .d-print-none {
    display: none !important;
  }
}
</style>